import { useEffect, useLayoutEffect } from 'react';

/**
 * useLayoutEffect in the browser, useEffect on the server.
 *
 * Neither runs during server rendering; the switch only avoids React 18's "useLayoutEffect does
 * nothing on the server" warning for components that render on both sides.
 *
 * Use it when a state update made on mount has to land in the same render as updates made from
 * componentDidMount. Under hydrateRoot those are synchronous, while updates from a passive
 * useEffect are applied in a later render (CORE-79329).
 */
const useIsomorphicLayoutEffect = __SERVER__ ? useEffect : useLayoutEffect;

export default useIsomorphicLayoutEffect;
